import list_icon from '@/assets/img/device/mg68/list_icon_se.png'
import { Mg68 } from './mg68'
import { LightEffectModeType } from '@/define/light'
import { EffectIndex, KK } from '@/define/define'

export class Mg68SE extends Mg68 {
  name: string = 'MG68_SE'
  icon: string = list_icon
  width: number = 656
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = {}

  fnDisableKeys: KK[] = [
    0x1, 0x7, 0xd, 0x13, 0x19, 0x1f, 0x25, 0x2b, 0x31, 0x37, 0x3d, 0x43, 0x49,
    // 0x4f, // backspace
    // 0x44, [{
    // 0x4a, }]
    0x9, 0xf,
    // 0xb,   win
    // 0x59,   →
    0x5e, 0x5f,
    // 0x52,   ↑
    // 0x4d,   ←
    // 0x53,   ↓
    0x65, 0x3b, 0x11,
  ]
}
